<template>
  <el-dialog :visible.sync="visible" title="版型信息" width="1000px" :before-close="close" :closeOnClickModal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="版型编码:" prop="modelCode">
        <el-input v-model="form.modelCode" disabled placeholder="请输入" style="width:500px"></el-input>
      </el-form-item>
      <el-form-item label="版型状态:" prop="status">
        <el-select v-model="form.status" size="medium" placeholder="请选择版型状态" style="width:300px">
          <el-option label="在售" :value="1" />
          <el-option label="下架" :value="0" />
          <el-option label="缺货" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item label="版型分类:" prop="categoryName">
        <!-- <el-input v-model="form.categoryName" :disabled="detail.firstTimeOnShelves" placeholder="请输入" maxlength="50" style="width:500px" @input="handleInput"></el-input> -->
        <el-select v-model="form.categoryName" :disabled="detail.firstTimeOnShelves" size="medium" placeholder="请选择版型分类" style="width:300px;">
          <el-option v-for="item in categoryNames" :key="item.categoryName" :label="item.categoryName" :value="item.categoryName" />
        </el-select>
      </el-form-item>
      <el-form-item label="kaka品类:" prop="kkCategoryId">
        <template #label>
          kaka品类
          <el-tooltip class="item" effect="dark" content="kaka品类用户后期用户设计生成kaka产品" placement="bottom-start">
            <i class="el-icon-warning-outline" style="font-size:18px;"></i>
          </el-tooltip>
        </template>
        <el-cascader ref="cascader" placeholder="请选择品类" v-model="form.kkCategoryId" :options="categoryOptions" size="medium" :props="{ value: 'categoryId', label: 'name', children: 'childList', emitPath: false }" filterable clearable  style="width:300px" @change="(e) => changeCascader(e)">
          <template slot-scope="{ node, data }">
            <span>{{ data.name }}</span>
            <span v-if="!node.isLeaf"> ({{ data.childList.length }}) </span>
          </template>
        </el-cascader>
      </el-form-item>
      <el-form-item label="商品名称:" prop="enName">
        <el-input v-model="form.enName" placeholder="请输入商品名称" style="width:500px"></el-input>
      </el-form-item>
      <el-form-item label="网址:">
        {{ kakaUrl }}{{ form.seoSearchTerm }}
      </el-form-item>
      <el-form-item label="SEO标题:" prop="seoTitle">
        <el-input v-model="form.seoTitle" placeholder="请输入SEO标题" style="width:500px"></el-input>
      </el-form-item>
      <el-form-item label="SEO关键词:">
        <el-input v-model="form.seoKeyWords" placeholder="请输入SEO关键词" style="width:500px"></el-input>
      </el-form-item>
      <el-form-item label="SEO描述:">
        <el-input v-model="form.seoDescription" type="textarea" :rows="3" placeholder="请输入SEO描述" style="width:500px"></el-input>
      </el-form-item>
      <el-form-item label="描述:" prop="enDescription">
        <RichEditor :value="form.enDescription" @input="(data) => (form.enDescription = data)" />
      </el-form-item>
      <el-form-item v-if="visible" label="设计区域:" label-position="top">
        <div>正面图：</div>
        <div class="design">
          <canvas id="canvas" width="500" height="500"></canvas>
        </div>
        <template v-if="detail.backImageUrl">
          <div>背面图：</div>
          <div class="design">
            <canvas id="backCanvas" width="500" height="500"></canvas>
          </div>
        </template>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button :loading="loadingBtn" type="primary" size="medium" @click="confirm">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/fabric.js/2.2.3/fabric.js"></script>
<script>
import API from '@/api'
import RichEditor from '@/views/operation/copywriting/components/RichEditor.vue'
const rules = {
  modelCode: [
    { required: true, message: '请输入版型编码', trigger: 'blur' },
  ],
  status: [
    { required: true, message: '请选择版型状态', trigger: 'change' },
  ],
  categoryName: [
    { required: true, message: '请输入版型分类', trigger: 'change' },
  ],
  kkCategoryId: [
    { required: true, message: '请选择kaka品类', trigger: 'change' },
  ],
  enName: [
    { required: true, message: '请输入商品名称', trigger: 'blur' },
  ],
  seoTitle: [
    { required: true, message: '请输入SEO标题', trigger: 'blur' },
  ],
  enDescription: [
    { required: true, message: '请输入版型描述', trigger: 'blur' },
  ]
}

export default {
  components: { RichEditor },
  props: {
    categoryNames: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      visible: false,
      rules,
      kakaUrl: process.env.VUE_APP_KAKACLO_URL+'/podModel-detail',
      form: {},
      detail: {},
      categoryOptions: [], // 品类下拉框数据源
      loadingBtn: false
    }
  },
  mounted() {
    this.getCategoryList()
  },
  watch: {
    'form.categoryName'() {
      this.detail.firstTimeOnShelves ? this.form.seoSearchTerm  : this.$set(this.form, 'seoSearchTerm', `/${this.form.categoryName}-${this.form.modelCode}`)
    }
  },
  methods: {
    show(id) {
      this.visible = true
      this.getCustomModelDetail(id)
    },
    getCustomModelDetail(id) {
      API.getCustomModelDetail(id).then(({ code, message, data }) => {
        if (code !== 10000) return this.$message.error(message)
        this.detail = data
        this.form = {
          categoryName: data.categoryName,
          enDescription: data.enDescription,
          id: data.id,
          kkCategoryId: data.kkCategoryId,
          modelCode: data.modelCode,
          seoTitle: data.firstTimeOnShelves ? data.seoTitle : data.enName,
          seoSearchTerm: data.firstTimeOnShelves ? data.seoSearchTerm : `/${this.form.categoryName}-${this.form.modelCode}`,
          seoDescription: data.firstTimeOnShelves ? data.seoDescription : data.enName,
          seoKeyWords: data.firstTimeOnShelves ? data.seoKeyWords : `${data.modelCode},${data.categoryName},${data.enName}`,
          status: data.status,
          enName: data.enName,
          designAreaContent: data.designAreaContent
        }
        this.$nextTick(() => {
          this.initDesign()
        })
      })
    },

    // 获取品类列表
    async getCategoryList() {
      let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000, type: 2 })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        this.categoryOptions = data.list
      }
    },
    deletechildList(arr) {
      // 删除最后一级为空的childList字段
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    },

    // 切换kaka品类
    changeCascader(value) {
      if (value) {
        this.categoryOptions.forEach((item) => {
          if (item.categoryId === value) {
            this.detail.kakaCategoryName = item.name
          }
        })
      } else {
        this.detail.kakaCategoryName = null
      }
    },
    // 初始化设计器
    initDesign() {
      let json = this.detail.designAreaContent ? JSON.parse(this.detail.designAreaContent) : undefined
      if (json) {
        this.restore(json)
        return
      }
      // 正面图
      this.createCanvas('canvas', this.detail.imageUrl)
      // 背面图
      console.log('背面图', this.detail)
      this.detail.backImageUrl && this.createCanvas('backCanvas', this.detail.backImageUrl)
    },
    // 创建画布
    createCanvas(id, imgUrl) {
      let canvas = new fabric.Canvas(id);
      fabric.Image.fromURL(imgUrl, (img) => {
        // 将图片设置成背景
        canvas.setBackgroundImage(img,
          canvas.renderAll.bind(canvas), // 刷新画布
          { //保证背景图1:1铺满容器
          scaleX: canvas.width / img.width, //计算出图片要拉伸的宽度
          scaleY: canvas.width / img.width //计算出图片要拉伸的高度
          }
        )
      })
      let rect = new fabric.Rect({
        left: 150,
        top: 100,
        width: 200,
        height: 300,
        fill: 'transparent',
        stroke: '#666',
        strokeWidth: 3,
        strokeDashArray: [10, 8],
      })
      canvas.add(rect)
      this.$set(this.detail, id, canvas)
    },
    // 设计器数据转json
    saveJson(value) {
      let json = this.detail[value].toJSON();
      return json
    },
    // 设计器数据渲染
    restore(json) {
      if (json.frontImg) {
        let canvas = new fabric.Canvas('canvas')
        canvas.loadFromJSON(json.frontImg, function() {
        // 回调函数确保所有对象都被加载到画布上后执行
          var objects = canvas.getObjects()
          canvas.renderAll()
        })
        this.$set(this.detail, 'canvas', canvas)
      } else {
        this.createCanvas('canvas', this.detail.imageUrl)
      }
      if (json.backImg) {
        let backCanvas = new fabric.Canvas('backCanvas');
        backCanvas.clear();
        backCanvas.loadFromJSON(json.backImg, function() {
        // 回调函数确保所有对象都被加载到画布上后执行
          var objects2 = backCanvas.getObjects()
          backCanvas.renderAll()
        })
        this.$set(this.detail, 'backCanvas', backCanvas)
      } else {
        this.detail.backImageUrl && this.createCanvas('backCanvas', this.detail.backImageUrl)
      }
    },

    // 关闭
    close() {
      this.detail.canvas.clear()
      this.detail.backCanvas && this.detail.backCanvas.clear()
      this.detail = {}
      this.$refs.form.resetFields()
      this.visible = false
    },
    // 确认提交
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        this.loadingBtn = true
        this.form.designAreaContent = JSON.stringify({
          frontImg: this.saveJson('canvas'),
          backImg: this.detail.backImageUrl ? this.saveJson('backCanvas') : undefined
        })
        API.editCustomModel(this.form).then(({ code, message }) => {
          if (code !== 10000) return this.$message.error(message)
          this.$emit('setSuccess')
          this.close()
        }).finally(() => {
          this.loadingBtn = false
        })
      })
    },
    // 只能输入英文和数字
    handleInput(e) {
      this.$set(this.form, 'categoryName', e.replace(/[^a-zA-Z0-9 ]+/g, '').trim())
    },
  }
}
</script>

<style lang="scss" scoped>
.design {
  canvas {
    border: 1px solid #f5f5f5;
  }
}
</style>
